import React from "react";
import styled from "styled-components";
import { useIntl } from "react-intl";
import { exchangeOnlineWizardMessages } from "../messages";

type SummaryProps = {
  channelName: string;
  chanelDesc: string;
  accountName: string;
  sender: string;
  recipients: string[];
};

export const Summary = ({
  channelName,
  chanelDesc,
  accountName,
  sender,
  recipients,
}: SummaryProps) => {
  const intl = useIntl();

  return (
    <>
      <ListWrapper>
        <Text>
          <b>{intl.formatMessage(exchangeOnlineWizardMessages.channelFieldName)}:</b> {channelName}
        </Text>
        <Text>
          <b>{intl.formatMessage(exchangeOnlineWizardMessages.description)}:</b> {chanelDesc}
        </Text>
      </ListWrapper>
      <ListWrapper>
        <Text>
          <b>{intl.formatMessage(exchangeOnlineWizardMessages.userAccount)}:</b> {accountName}
        </Text>
      </ListWrapper>
      <ListWrapper>
        <Text>
          <b>{intl.formatMessage(exchangeOnlineWizardMessages.mailSender)}:</b> {sender}
        </Text>
        <Text>
          <b>{intl.formatMessage(exchangeOnlineWizardMessages.mailRecipients)}:</b>{" "}
          {recipients?.join(", ")}
        </Text>
      </ListWrapper>
    </>
  );
};

const Text = styled.p`
  margin: 0;
`;

const ListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding-top: 15px;
`;
